import { defineMessages } from "react-intl";

const messages = defineMessages({
    beginner: {
        id: "choir.meta.general.level.beginner",
        defaultMessage: "Beginner"
    },
    intermediate: {
        id: "choir.meta.general.level.intermediate",
        defaultMessage: "Intermediate"
    },
    advanced: {
        id: "choir.meta.general.level.advanced",
        defaultMessage: "Advanced"
    },
    concert: {
        id: "choir.meta.general.goal.concert",
        defaultMessage: "Concert"
    },
    recording: {
        id: "choir.meta.general.goal.recording",
        defaultMessage: "Video & recording"
    },
    joyfulMusic: {
        id: "choir.meta.general.goal.joyfulMusic",
        defaultMessage: "Joyful music"
    },
    blattNight: {
        id: "choir.meta.general.goal.blattNight",
        defaultMessage: "Sight reading"
    },
    church: {
        id: "choir.meta.general.repertoirNature.church",
        defaultMessage: "Church music"
    },
    secular: {
        id: "choir.meta.general.repertoirNature.secular",
        defaultMessage: "Secular music"
    },
    classicalChoir: {
        id: "choir.meta.general.style.classicalChoir",
        defaultMessage: "Classical choir"
    },
    renaissanceMadrigal: {
        id: "choir.meta.general.style.renaissanceMadrigal",
        defaultMessage: "Renaissance madrigal"
    },
    oratorio: {
        id: "choir.meta.general.style.oratorio",
        defaultMessage: "Oratorio"
    },
    motet: {
        id: "choir.meta.general.style.motet",
        defaultMessage: "Motet"
    },
    gospel: {
        id: "choir.meta.general.style.gospel",
        defaultMessage: "Gospel"
    },
    pop: {
        id: "choir.meta.general.style.pop",
        defaultMessage: "Pop"
    },
    rock: {
        id: "choir.meta.general.style.rock",
        defaultMessage: "Rock"
    },
    jazz: {
        id: "choir.meta.general.style.jazz",
        defaultMessage: "Jazz"
    },
    folk: {
        id: "choir.meta.general.style.folk",
        defaultMessage: "Folk"
    },
    world: {
        id: "choir.meta.general.style.world",
        defaultMessage: "World"
    },
    modernChoir: {
        id: "choir.meta.general.style.modernChoir",
        defaultMessage: "Modern choir",
    },
    experimental: {
        id: "choir.meta.general.style.experimental",
        defaultMessage: "Experimental"
    },
    electronic: {
        id: "choir.meta.general.style.electronic",
        defaultMessage: "Electronic"
    },
    other: {
        id: "choir.meta.general.style.other",
        defaultMessage: "Other"
    },
    score: {
        id: "choir.meta.general.wayOfSinging.fromScore",
        defaultMessage: "From music sheet"
    },
    byHeart: {
        id: "choir.meta.general.wayOfSinging.byHeart",
        defaultMessage: "By heart"
    },
    catholic: {
        id: "choir.meta.general.denomination.catholic",
        defaultMessage: "Catholic"
    },
    reformed: {
        id: "choir.meta.general.denomination.reformed",
        defaultMessage: "Reformed"
    },
    lutheran: {
        id: "choir.meta.general.denomination.lutheran",
        defaultMessage: "Lutheran"
    },
    greekCatholic: {
        id: "choir.meta.general.denomination.greekCatholic",
        defaultMessage: "Greek catholic"
    },
    baptist: {
        id: "choir.meta.general.denomination.baptist",
        defaultMessage: "Baptist"
    },
    methodist: {
        id: "choir.meta.general.denomination.methodist",
        defaultMessage: "Methodist"
    },
});

export default messages;
